/* eslint-disable @typescript-eslint/no-floating-promises */
import { ReactElement, useState } from 'react';

import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { toast } from 'react-toastify';

import { LoadingBar } from '@/components';
import { HorizontalTabs } from '@/components/tabs';

import {
  BrandingInformation,
  Closing,
  EmailTemplates,
  Formatting,
  GlobalLetterOptions,
  LetterTemplates,
} from '../components';
import {
  useGetGlobalLetter,
  useGlobalLetterForm,
  useSaveGlobalLetter,
} from '../hooks';

export const GlobalLetterSettings = (): ReactElement => {
  const form = useGlobalLetterForm();
  const [selectedTab, setSelectedTab] = useState(0);
  const { mutate: saveGlobalLetter, isPending } = useSaveGlobalLetter();
  const { isLoading } = useGetGlobalLetter({
    reset: form.reset,
  });

  const handleSave = () => {
    const values = form.getValues();
    saveGlobalLetter(values);
    toast.success('Changes are updated successfully!');
  };

  const tabs = [
    { label: 'Letter Templates', component: <LetterTemplates /> },
    { label: 'Email Templates', component: <EmailTemplates /> },
    {
      label: 'Global Letter Options',
      component: (
        <GlobalLetterOptions handleSave={handleSave} isPending={isPending} />
      ),
    },
    {
      label: 'Formatting',
      component: <Formatting handleSave={handleSave} isPending={isPending} />,
    },
    {
      label: 'Closing',
      component: <Closing handleSave={handleSave} isPending={isPending} />,
    },
    { label: 'Branding Information', component: <BrandingInformation /> },
  ];

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  if (isLoading) return <LoadingBar />;

  return (
    <Box width="100%">
      <FormProvider {...form}>
        <HorizontalTabs
          tabs={tabs}
          selectedTab={selectedTab}
          handleChange={handleChange}
        />
      </FormProvider>
    </Box>
  );
};
